import { InteractionStatus, InteractionType } from "@azure/msal-browser";
import {
  MsalAuthenticationTemplate,
  useAccount,
  useIsAuthenticated,
  useMsal,
} from "@azure/msal-react";
import { Box } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loginRequest } from "../authConfig";
import { ROUTES } from "../routes/constants";
import { ErrorComponent } from "./shared/Error";
import { Spinner } from "./shared/Spinner";

const Login = () => {
  const navigate = useNavigate();
  const { instance, inProgress, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(ROUTES.UPLOAD);
    }
    // eslint-disable-next-line
  }, [inProgress, account, instance, navigate]);
  const authRequest = {
    ...loginRequest,
  };
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      loadingComponent={Spinner}
      errorComponent={ErrorComponent}
    >
      <Box>{inProgress !== InteractionStatus.None ? <Spinner /> : null}</Box>
    </MsalAuthenticationTemplate>
  );
};

export default Login;
